import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Placeholder } from '$uikit';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { IcSuccess72 } from '$assets';
import { useTranslator } from '$hooks';
import { ConnectTelegramSheetProps } from './ConnectTelegramSheet.interface';
import { mainActions } from '$store/main';

export const ConnectTelegramSheet: FC<ConnectTelegramSheetProps> = (props) => {
  const { url } = props;
  const t = useTranslator();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(mainActions.setPopup(null));
  }, []);

  return (
    <BottomSheet>
      <Placeholder
        icon={<IcSuccess72 />}
        title={t('connect_telegram_title')}
        actions={
          <Button href={url} target="_blank" onClick={handleClick}>
            {t('connect_telegram_btn')}
          </Button>
        }
      >
        {t('connect_telegram_caption')}
      </Placeholder>
    </BottomSheet>
  );
};
